module.exports = __webpack_public_path__ + "img/undraw_Note_list_re_r4u9.c93cb80c.svg";